import { render, staticRenderFns } from "./buyRecords.vue?vue&type=template&id=21cc14d6&"
import script from "./buyRecords.vue?vue&type=script&lang=js&"
export * from "./buyRecords.vue?vue&type=script&lang=js&"
import style0 from "./buyRecords.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports